"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var luxon_1 = require("luxon");
var universal_cookie_1 = __importDefault(require("universal-cookie"));
var helpers_1 = require("./helpers");
var cookies = new universal_cookie_1.default();
/**
 * Determines if the connection is currently utilizing HTTPS.
 * @returns {boolean} True if the connection is HTTPS.
 */
exports.isSecure = function () {
    return helpers_1.isDefined(location) && location.protocol === "https:";
};
/**
 * Retrieves a value stored in an HTTP cookie.
 * @param {string} key The name of the cookie to lookup.
 * @returns {?any} The object in the cookie store or undefined.
 */
exports.getCookie = function (key) {
    var item = cookies.get(key);
    return helpers_1.isBlank(item) ? undefined : item;
};
/**
 * Stores a value inside of a cookie.
 * @param {string} key The name of the cookie to create or set.
 * @param {string} value The value to store in that cookie.
 * @param {number} days The number of days until the cookie expires.
 */
exports.setCookie = function (key, value, days) {
    var options = {
        expires: luxon_1.DateTime
            .utc()
            .plus({ days: days })
            .toJSDate(),
        maxAge: luxon_1.Duration.fromObject({ days: days }).as('seconds'),
        path: "/",
        secure: exports.isSecure()
    };
    cookies.set(key, value, options);
};
/**
 * Clears a browser cookie matching a supplied key.
 * @param {string} key The name of the cookie to remove.
 */
exports.removeCookie = function (key) {
    cookies.remove(key, {
        path: "/"
    });
};
